<div>
    <h1 mat-dialog-title>Termintyp auswählen</h1>
    <div mat-dialog-content>
        <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="selectedEventType">
                <mat-option *ngFor="let ele of eventTypeList" [value]="ele.type">{{ ele.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">Abbrechen</button>
        <button mat-button [mat-dialog-close]="selectedEventType" cdkFocusInitial>Ok</button>
    </div>
</div>
